import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Validators, UntypedFormBuilder } from '@angular/forms';
import { IFacility } from 'src/app/shared/models/IFacility';
import { ResourcesService } from 'src/app/shared/services/resources.service';
import { Sort } from 'src/app/shared/util/sort';
import { FacilitiesService } from './shared/facilities.service';
import { FacilitiesUtility } from './shared/facilities.util';

@Component({
  selector: 'app-facilities',
  templateUrl: './facilities.component.html',
  styleUrls: ['./facilities.component.css']
})
export class FacilitiesComponent implements OnInit {
  hospitals: IFacility[];
  pageSizeOptions = [];
  pageSize = 25;
  pageSizeDisplay = 25;
  pageIndex = 1;
  isLoading: boolean = false;
  totalNumber: number;
  cols: any;
  resourceKeyValue: any = null;
  numberOfPages = 0;
  hospitals2display: IFacility[];
  rowHospitals: IFacility[];
  //direction: string = 'desc';
  directionColumnName: string = 'asc';
  sortableState = '1';
  selectedItem = 2;
  isDefaultSort = true;

  rowsPerPageForm = this.fb.group({
    rowsPerPage: ['0', [Validators.required]],
  })

  searchHospitalsForm = this.fb.group({
    term: [''],
  });

  @ViewChild("hospitalTable", { read: ElementRef }) hospitalTable: ElementRef;

  constructor(private facilitiesService: FacilitiesService,
    private fb: UntypedFormBuilder,
    private resourcesService: ResourcesService,
    private renderer: Renderer2) { }

  ngOnInit(): void {
    this.resourcesService.bsObject.subscribe(result => {
      result && (this.resourceKeyValue = result);
      this.pageSizeOptions = [10, 25, 50, 100, { showAll: this.resourceKeyValue.showAll }];
      this.isLoading = true;
      this.getFacilities();
    });


  }

  getFacilities(): void {
    this.facilitiesService.getFacilities().subscribe(response => {
      this.rowHospitals = response
      this.rowHospitals.forEach(x => {
        x.fullAddress = this.formatAddress(x.address1, x.address2, x.city, x.state, x.zipcode)
      })
      this.hospitals = this.rowHospitals;
      this.totalNumber = this.rowHospitals.length;
      this.numberOfPages = Math.ceil(this.totalNumber / this.pageSize);
      //first ordering the records by name asc
      this.columnSort('name', this.directionColumnName);
      this.isLoading = false;
    },
      (error) => {
        if (error.code == 404) {
          this.hospitals = [];
          this.rowHospitals = [];
          this.searchHospitalsForm.controls['term'].disable();
          this.isLoading = false;
          return;
        }
      });
  }
  refreshHospitals() {
    this.isDefaultSort = true;
    this.hospitals2display = this.hospitals
      .map((facility, i) => ({ id: i + 1, ...facility }))
      .slice((this.pageIndex - 1) * this.pageSize, (this.pageIndex - 1) * this.pageSize + this.pageSize);
    this.numberOfPages = Math.ceil(this.totalNumber / this.pageSize);

    if (this.hospitalTable) {
      let elements: Element[] = this.hospitalTable.nativeElement.getElementsByClassName('sorted-desc') || this.hospitalTable.nativeElement.getElementsByClassName('sorted-asc');
      if (elements && elements.length) {
        Array.from(elements).forEach((element: any) => {
          this.renderer.removeClass(element, 'sorted-desc');
          this.renderer.removeClass(element, 'sorted-asc');

          if (element.getAttribute('data-order') && element.getAttribute('data-order') == 'asc') {
            element.setAttribute('data-order', 'desc');
          }
        });
      }

      let sortElement = this.hospitalTable.nativeElement.getElementsByClassName('initialSort');
      if (sortElement && sortElement.length) {
        this.renderer.addClass(sortElement[0], 'sorted-asc');
      }
    }

    this.sortableState = '1';
    this.columnSort('name', this.directionColumnName);
  }

  columnSort(property: string, direction: string) {
    const dataSort = new Sort();
    this.hospitals.sort(dataSort.startSort(property, direction));
  }

  matches(hospital: IFacility, term: string) {
    return hospital.name.toLowerCase().includes(term.toLocaleLowerCase());
  }

  search(event: Event) {
    this.isDefaultSort = true;
    this.hospitals = this.rowHospitals;
    const filterValue = event ? (event.target as HTMLInputElement).value : ' ';
    this.hospitals = this.hospitals.filter(x => this.matches(x, filterValue));
    this.totalNumber = this.hospitals.length;
    this.refreshHospitals();
    this.columnSort('name', this.directionColumnName);
  }

  isNumber(val): boolean { return typeof val === 'number'; }

  formatAddress(address1: string, address2: string, city: string, state: string, zipCode: string): string {
    let formattedAddress = '';
    formattedAddress = address1 + ', ' + address2 + (address2.length > 0 ? ', ' : '') + city + ', ' + state + ' ' + zipCode;
    return formattedAddress;
  }
}
